import { cn } from '@strategy4kids/ui';

export interface ScoreRow {
  readonly key: string;
  readonly label: string;
  readonly value: string | number;
  /** What this round added (or took off), e.g. "+13". */
  readonly delta?: string;
  readonly you?: boolean;
  readonly leading?: boolean;
}

/** The running score, always on screen: one pill per player or team, the leader marked. */
export function ScoreStrip({
  testid,
  title,
  rows,
  note,
}: {
  readonly testid: string;
  readonly title: string;
  readonly rows: readonly ScoreRow[];
  readonly note?: string;
}) {
  return (
    <div
      className="glass glass-light flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl px-4 py-2.5 shadow-sm"
      data-testid={testid}
      data-appdom-id={testid}
      data-appdom-type="Panel"
    >
      <span className="font-display text-base font-bold text-fg lg:text-lg">{title}</span>
      <ul className="flex flex-wrap items-center gap-2">
        {rows.map((r) => (
          <li
            key={r.key}
            data-testid={`${testid}-${r.key}`}
            className={cn(
              'flex items-center gap-2 rounded-full border px-3 py-1 text-sm font-bold lg:text-base',
              r.you ? 'border-accent bg-accent-soft' : 'border-border bg-surface',
              r.leading && 'ring-2 ring-sun',
            )}
          >
            <span className="text-fg-muted">{r.label}</span>
            <span className="text-fg">{r.value}</span>
            {r.delta ? <span className="text-accent">{r.delta}</span> : null}
          </li>
        ))}
      </ul>
      {note ? <span className="text-sm font-semibold text-fg-muted lg:ml-auto">{note}</span> : null}
    </div>
  );
}
